import { render, staticRenderFns } from "./Practice.vue?vue&type=template&id=885830b4&scoped=true&lang=html&"
import script from "./Practice.vue?vue&type=script&lang=ts&"
export * from "./Practice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885830b4",
  null
  
)

export default component.exports